import React, {Fragment} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBlog, faRainbow  } from '@fortawesome/free-solid-svg-icons';
import Button from 'react-bootstrap/Button';
import MovingText from 'react-moving-text';
import { Container, Row, Col , Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import styles from './About.css'

const About = () =>{
   
    return (
        <Fragment>
        
   
       
<Container>
  <Row>
    <Col >
    <MovingText
      type="pulse"
      duration="1000ms"
      delay="1s"
      direction="normal"
      timing="linear"
      iteration={4}>
      <Image src="images/paint.PNG" roundedCircle   fluid/></MovingText>
    </Col>
    <Col >
    <MovingText
      type="fadeIn"
      duration="1000ms"
      delay="1s"
      direction="normal"
      timing="linear"
      iteration={1}>
<span style={{width:"70%", fontFamily:"''Patrick Hand', cursive", 
 margin:"10px", padding:"5px", marginTop:"10px",color:" darkred", 
 fontSize:"22px", textAlign:"match-parent", marginRight:"20px", paddingLeft:"5px"
 ,backgroundColor:"greenyellow"}}>
    <ul><li>Collaborating</li><li>Creating </li><li>
Always Growing</li> </ul></span></MovingText>
</Col>
</Row>
<br /><br /><hr
        style={{
          color: 'white',
          backgroundColor:'navy',
            height: 20,
            borderColor : 'darkred'
        }}
    />
<Row>
  <Col >

<MovingText
      type="flipFromLeftToCenter"
      duration="1000ms"
      delay="1s"
      direction="normal"
      timing="linear"
      iteration={1}>
      
      <span style={{width:"50%", fontFamily:"''Patrick Hand', cursive", 
 margin:"10px", padding:"5px", marginTop:"10px",color:"#080C68  ", 
 fontSize:"20px", textAlign:"match-parent", marginRight:"20px", paddingLeft:"5px",
 
 
 }}>
   I have a proven track record of success in work, in my past jobs as a web developer. 
    I am a detailed oriented, fast paced, creative and committed engineer.
  My superior capacity to tackle time-sensitive projects, and my proven ability to deliver best.
  </span></MovingText>
  </Col>
  <Col>
  <MovingText
      type="flipFromLeftToCenter"
      duration="1000ms"
      delay="1s"
      direction="normal"
      timing="linear"
      iteration={1}>
  <span style={{width:"50%", fontFamily:"''Patrick Hand', cursive", 
 margin:"10px", padding:"5px", marginTop:"10px",color:"#080C68", 
 fontSize:"20px", textAlign:"match-parent", marginRight:"20px", paddingLeft:"5px",marginLeft:"20px"}}>
  My experience as a volunteer at school made it necessary for me to 
  focus be patient and enabled me to work with all types of people from students to teachers and business. Currently 
graduated in Illinois Institute of Technology, Chicago, IL, USA, in Information Technology. 
    </span>


    </MovingText>

</Col>
</Row>

</Container>   

<br /><br /><br />
     <div id="down">
     <span style={{fontFamily:"'Lobster', cursive", fontSize:"25px",  color:"gray"
    ,textAlign:"match-parent", position:"inherit", float:"inline-start",margin:'10px'}}>
      <ul>What do you do in your free time?
      </ul></span>
      <span   style={{fontFamily:"'Lobster', cursive",fontSize:"20px",  color:"gray"
    ,textAlign:"match-parenter", position:"inherit", float:"inline-end",margin:'10px'}} > <ul >Read good book which can make me more knowledgeable
      </ul>
      <ul> <a href="#/Blog"> Start a blog about something to do that interests me </a>

    
     <Button variant="contained" color="primary" href="#/Blog">
                  <FontAwesomeIcon icon={faBlog}/></Button>
      </ul>
     <ul> I prefer parks in the evening where you get a fresh surrounding with cool air 
     </ul>
     </span></div>
     <br />
       <style>{'body { background-color: white; }'} </style>
    
       </Fragment>
       
    );
   
}


export default About;
 